module.exports = __webpack_public_path__ + "static/media/english.bd360e51.png";